export default {
	delivery: "Delivery",
    payment: "Payment",
	approval: "Approval"
};
